import Vue from 'vue'
import App from './App'
import router from './router'
import '@/style/reset.css'
import '@/common/elementui.js'
import './style/public.scss'
import $ from 'jquery'
import promise from 'es6-promise'
import ElementUI from 'element-ui';
import 'default-passive-events'
const echarts = require('echarts');
import store from './store'
import VueBus from 'vue-bus';
import {
  tokenLogin,
} from '@/http/api.js'

Vue.use(VueBus);

Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

//防止ElementUI。Dialog滚动条出现而导致页面抖动
ElementUI.Dialog.props.lockScroll.default = false;

router.beforeEach(async (to, from, next) => {
  console.log();
  if(to.query.access_token){

     await tokenLogin({
      access_token:to.query.access_token
     }).then((res) => {
      if (res.meta.status == 10000) {
        localStorage.setItem('access_token', res.data.access_token);
        localStorage.setItem('loginType', JSON.stringify([{type:res.data.type}]))
        sessionStorage.setItem('loginType',JSON.stringify([{type:res.data.type}]))
        localStorage.setItem('type', JSON.stringify(res.data.type))
        if (res.data.type == 0) {
          next('/home/fangzhen/work')
          } else if (res.data.type == 1) {
            next('/home/fangzhen/stuWork')
          }
      }else{
        ElementUI.Message.warning({
          message: 'token 登陆失败',
        });
      }
    })
  }

  let type = localStorage.getItem('type')

  let loginType = sessionStorage.getItem('loginType')

  if(to.name != 'login' && !loginType){
    alert('请先登陆')
    router.push({
      path: '/login'
    })
    return
  }

  //如果是学生登陆
  if(type == 1 && to.name != 'stuWork' && to.name != 'login' && !loginType){

    alert('没有权限，请重新登陆')

    router.push({
      path: '/'
    })
    return
  }

  if (to.meta.title) {
    document.title = to.meta.title
  }

  if(to.fullPath == '/home/fangzhen/workDetail'){
    router.push({
      path: '/home/fangzhen/work'
    })
  }

  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js